// extracted by mini-css-extract-plugin
module.exports = {"root":"Kpi_root__5Oj0e","isOdd":"Kpi_isOdd__bxiAC","numberWrapper":"Kpi_numberWrapper__SM9Yu","number":"Kpi_number__L_1QD","content":"Kpi_content__oTgZk"};